import fetch from 'lib/decorated-fetch'
import { logger } from './slardar-utils'

export interface IConfig {
  declare_strategy: string
  api_intercept: string
}
const defaultConfig: IConfig = {
  declare_strategy: '1',
  api_intercept: '[]',
}
let promise: Promise<IConfig> | null = null
export default function getTCCConfig() {
  if (promise) return promise
  promise = new Promise(async (resolve) => {
    try {
      const response = await fetch(
        'https://lf3-config.bytetcc.com/obj/tcc-config-web/tcc-v2-data-motor.fe.pc-default'
      )
      resolve(Object.assign({}, defaultConfig, response.data as IConfig))
    } catch (error) {
      logger.error(
        `[/motor/tcc/config/web/get onError] error message: ${
          (error as Error).message
        }]`
      )
      resolve({ ...defaultConfig })
    }
  })
  return promise
}
